import { i18nMark } from '@lingui/core'
import { Trans } from '@lingui/macro'
import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@material-ui/core'
import { FieldProps } from 'formik'
import React from 'react'
import { EBillingPlan } from 'shopify-payment-core'

import { i18n } from '../i18n'

interface IProps extends FieldProps<EBillingPlan> {
  allowFree?: boolean
}

export const billingPlanLabels = {
  [EBillingPlan.FREE]: i18nMark('Zdarma'),
  [EBillingPlan.MONTHLY]: i18nMark('Měsíčně (250,- Kč)'),
  [EBillingPlan.ONETIME]: i18nMark('Jednorázově (6000,- Kč)'),
}

export const AccountBillingPlan: React.FC<IProps> = ({
  field,
  form,
  allowFree = false,
}) => {
  return (
    <FormControl>
      <FormLabel htmlFor="billingPlan">
        <Trans>Platební plán</Trans>
      </FormLabel>
      <RadioGroup
        id={field.name}
        name={field.name}
        value={field.value}
        onChange={(ev, value) => {
          form.setFieldValue(field.name, value)
        }}
      >
        {allowFree && (
          <FormControlLabel
            value={EBillingPlan.FREE}
            control={<Radio />}
            label={i18n._(billingPlanLabels[EBillingPlan.FREE])}
          />
        )}
        <FormControlLabel
          value={EBillingPlan.MONTHLY}
          control={<Radio />}
          label={i18n._(billingPlanLabels[EBillingPlan.MONTHLY])}
        />
        <FormControlLabel
          value={EBillingPlan.ONETIME}
          control={<Radio />}
          label={i18n._(billingPlanLabels[EBillingPlan.ONETIME])}
        />
      </RadioGroup>
    </FormControl>
  )
}
